<!-- Переключатель одного права или варианта видимости в настройках роли. -->
<template>
  <button
    type="button"
    class="permission-role-toggle-button"
    :class="{ 'permission-role-toggle-button--selected': selected }"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <span class="permission-role-toggle-button__dot"></span>
    {{ label }}
  </button>
</template>

<script>
export default {
  name: "PermissionRoleToggleButton",

  props: {
    label: {
      type: String,
      required: true,
    },
    selected: Boolean,
    disabled: Boolean,
  },

  emits: ["click"],
};
</script>

<style scoped>
.permission-role-toggle-button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px;
  border: 1px solid var(--color-grey);
  border-radius: 99px;
  background: var(--color-light);
  color: #666;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  white-space: nowrap;
  transition: background 0.13s, border-color 0.13s, color 0.13s,
    opacity 0.13s;
}

.permission-role-toggle-button:hover:not(:disabled) {
  border-color: var(--color-green-hover);
  color: var(--color-green-hover);
}

.permission-role-toggle-button--selected {
  border-color: var(--color-green);
  background: #ccf2ed;
  color: var(--color-green);
  font-weight: 500;
}

.permission-role-toggle-button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.permission-role-toggle-button__dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.35;
  transition: opacity 0.13s;
}

.permission-role-toggle-button--selected .permission-role-toggle-button__dot {
  opacity: 1;
}

@media (max-width: 768px) {
  .permission-role-toggle-button {
    padding: 10px 14px;
    font-size: 14px;
  }

  .permission-role-toggle-button__dot {
    width: 7px;
    height: 7px;
  }
}
</style>
